import React, { useState } from 'react'
import { 
  Col, 
  Row, 
  Image, 
  Input, 
  Space, 
  Button, 
  // Layout 
} from 'antd';
import { login } from '../../Utils/api/Auth';
import { 
  UserOutlined, 
  LockOutlined, 
  EyeInvisibleOutlined, 
  EyeTwoTone 
} from '@ant-design/icons';
// import { useNavigate } from "react-router-dom"
import HeaderImage from "../../Assets/Images/cpm-logo-removebg-preview.png"
import toast from 'react-hot-toast';
import { 
  // getToken, 
  refreshPage,
} from '../../Utils/Common';
import { PuffLoader } from 'react-spinners';
const Login = () => {
  // const navigate = useNavigate()
  const [loginCredential, setLoginCredential] = useState({
    username: '',
    password: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    const {name, value} = e.target
    setLoginCredential({
      ...loginCredential,
      [name]: value
    })
  }
  const onSubmit = async () => {
    setIsLoading(true);
    // values.username = values.email;
    const response = await login(loginCredential);
    if (response.data){
      localStorage.setItem('token', JSON.stringify(response.data.token));
      localStorage.setItem('user_id', JSON.stringify(response.data.user_id));
      localStorage.setItem('full_name', JSON.stringify(response.data.full_name));
      localStorage.setItem('role_id', JSON.stringify(response.data.role_id));
      localStorage.setItem('role_name', JSON.stringify(response.data.role_name));
      // localStorage.setItem('fullname', JSON.stringify(response.data.full_name));
      localStorage.setItem('token_expiry', JSON.stringify(response.data.token_expiry));

      toast.success(response.data.message)
      setTimeout(()=>{
        refreshPage();
        // navigate('/property')
      },[])
    } else {
      toast.error(response.error.messages.error_messages.message)
    }
    setIsLoading(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };
  return (
      <Row className='bg-login page'>
        <Col span={13} className='login-left-col'>
        
        </Col>
        <Col span={11} className='login-right-col'>
          <Row className='myt-logo center'>
            <Col className='center'>
              <Image
                width="70%" 
                src={HeaderImage}
                alt="login-image"
                preview={false}
                className='logo'
              />
            </Col>
          </Row>
          {/* <Row className='center space-bottom'>
            <Col className='login-title'>
              PROPERTY MANAGEMENT SYSTEM
            </Col>
          </Row> */}
          <Row className='center'>
            <Col>
              <Row className='space-bottom'>
                <Col>
                  <Input 
                    className='input-width login-fields padding-fields'
                    name='username'
                    size="large" 
                    placeholder="Username" 
                    onChange={(e) => handleChange(e)}
                    onKeyDown={handleKeyPress}
                    prefix={<UserOutlined />} 
                  />
                </Col>
              </Row>
              <Row className='space-bottom'>
                <Col>
                  <Space direction="vertical">
                    <Input.Password
                      className='input-width login-fields padding-fields'
                      size='large'
                      name='password'
                      onChange={(e) => handleChange(e)}
                      onKeyDown={handleKeyPress}
                      placeholder="Password"
                      iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                      prefix={<LockOutlined />}
                    />
                  </Space>
                </Col>
              </Row>
              <Row className='space-bottom center'>
                <Col>
                    {isLoading ? (
                      <PuffLoader color="#60A3D9" size={40} />
                    ) : (
                      <Button 
                        type="primary"
                        size='large'
                        className='login-fields login-btn'
                        onClick={onSubmit}
                        disabled={isLoading}
                      >
                        Login
                      </Button>
                    )}
                </Col>
              </Row>
              <Row className='center login-footer'>
                <div>
                  Powered by MYT Softdev Solutions Inc.
                </div>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
  )
}

export default Login
